import { jwtDecode } from "jwt-decode";
import { OpenAPI } from "matchi-api";
import { auth } from "matchi-auth";

// TEMPORARY. Added so the Amex-withdrawal notice (components/AmexRemovalNotice)
// stays out of the mobile E2E suites; remove it together with that notice
// after 1 October 2026, unless another temporary notice has started using it
// by then. To remove: delete this file, its line in utils/index.ts,
// __tests__/e2e-shopper.test.ts, test/fakeJwt.ts and the two E2E-path cases
// in __tests__/components.test.tsx.
//
// The mobile E2E suites (matchiapp/mobileapp) drive the real checkout on test
// with dedicated Keycloak accounts such as e2e-ios-1@e2e.matchi.com and
// e2e-android-1@e2e.matchi.com. Those scripts assert on a fixed page layout,
// so any transient UI we add to the checkout (a campaign or maintenance
// notice) breaks them for no reason and has to be un-broken again once the
// notice goes. Temporary UI checks this and stays out of their way.
//
// Permanent behaviour must never branch on it: the point of E2E is to
// exercise what real shoppers get.
const E2E_EMAIL_DOMAIN = "@e2e.matchi.com";

// Read the email from the bearer the checkout calls the API with, not from
// the Keycloak instance. The MATCHi app hands its own Keycloak ID token over
// as ?token=, and a re-opened checkout restores that same token from
// localStorage; on both paths utils/auth.ts returns before it ever initialises
// Keycloak, so auth.getIdTokenParsed() is undefined there and a Keycloak-only
// check would silently pass the mobile E2E accounts through. Every path that
// renders the form ends in updateOpenApiConfig(), which sets OpenAPI.TOKEN, so
// that is the one source present everywhere. The Keycloak fallback below is
// defensive only: by the time PaymentForm renders, OpenAPI.TOKEN is always set.
const shopperEmail = (): string | undefined => {
  const bearer = OpenAPI.TOKEN;
  if (typeof bearer === "string" && bearer) {
    try {
      return jwtDecode<KeycloakJWTPayload>(bearer).email;
    } catch {
      // Not a JWT we can read; fall through to Keycloak.
    }
  }
  return auth.getIdTokenParsed()?.email;
};

export const isE2EShopper = () =>
  shopperEmail()?.toLowerCase().endsWith(E2E_EMAIL_DOMAIN) ?? false;
